<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on }">
        <v-btn outlined color="primary" class="mt-2" @click.stop="on.click($event)">
          <v-icon left>mdi-image</v-icon>
          {{ $t("base.ImageGallery.btnTitle") }}
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="headline primary white--text" primary-title
          >{{ $t("base.ImageGallery.title") }}
        </v-card-title>
        <v-card-text>
          <!-- <v-container fluid> -->
          <div class="overflow-y-auto" style="max-height: 65vh">
            <v-row>
              <v-col v-for="(image, index) in images" :key="index" cols="4">
                <v-card @click="clicked(image)" flat tile class="d-flex">
                  <v-img :src="image.url" aspect-ratio="1" class="grey lighten-2">
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
          </div>
          <!-- </v-container> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false">{{ $t("common.cancel") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    clicked(image) {
      this.$emit("url", image);
      this.dialog = false;
    },
  },
  computed: {
    templateImages() {
      const imageNames = ["car", "bus", "food", "hotel", "meeting", "museum", "other", "plane"];
      // eslint-disable-next-line import/no-dynamic-require
      const imageUrls = imageNames.map((a) => ({ url: require(`@/assets/img/${a}.jpg`), path: a }));
      return imageUrls;
    },
    eventImages() {
      console.log("calculating gallery urls");
      const { imageUrls } = this.$store.state;
      const events = {
        ...this.$store.state.trip.events,
        ...this.$store.state.trip.travels,
      };
      const eventIds = Object.keys(events);
      const images = [];
      Object.values(this.$store.state.trip.cities).forEach((city) => {
        let imageName;
        if (city.image && city.image.includes("wikimedia")) {
          imageName = `${city.wiki_code}.${city.image.split(/[#?]/)[0].split(".").pop().trim()}`;
        } else if (city.image) {
          const pathWithParams = city.image.substring(city.image.lastIndexOf("/") + 1);
          const path = decodeURIComponent(pathWithParams.substring(0, pathWithParams.indexOf("?")));
          imageName = path;
        }
        images.push({ path: imageName, url: city.image });
      });
      eventIds.forEach((eventId) => {
        const url = imageUrls[eventId];

        if (url && events[eventId].files && events[eventId].files.header) {
          const path = events[eventId].files.header;
          if (!images.some((image) => image.path === path)) {
            images.push({ url, path });
          }
        }
      });

      console.log(images);
      return images;
    },
    images() {
      return [...this.templateImages, ...this.eventImages];
    },
  },
};
</script>
